import mitt from 'mitt';

export const EventBus = mitt();

export const events = {
  setPhoneSelectLoading: 'set-phone-select-loading',
  callQualityReportModal: 'report-modal',
};
